import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Announces } from '../../plugin-announce/model/announces';
import { Announce } from '../../plugin-announce/model/announce';
import { MessageBellService } from '../../services/message-bell.service';
import { AnnounceService } from '../../plugin-announce/announce.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'mir-active-announces-banner',
  templateUrl: './active-announces-banner.component.html',
  styleUrls: ['./active-announces-banner.component.css'],
  standalone: false,
})
export class ActiveAnnouncesBannerComponent implements OnInit, OnDestroy {
  announces: Announces;
  expanded = false;

  private subscription: Subscription;

  constructor(
    private bellService: MessageBellService,
    private announceService: AnnounceService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.subscription = this.bellService.announcesObservable.subscribe(
      (announces) => (this.announces = announces)
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }

  markAsRead(a: Announce): void {
    this.announceService.markAsRead(a).subscribe(() => {
      this.toastrService.success(a.title, 'Annonce marquée lue');
      this.bellService.reload();
    });
  }
}
